import thunk from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'

import rootReducer from './reducers'
import mockedPortal from './portal.mock'
import config from './config'
import { passcodeStore } from './modules/passcode'
import { getPasscode } from './modules/passcode/storage';

let store

const initialState = {
  info: { passcode: getPasscode(), language: config.defaultLanguage },
}
if (config.isMock) {
  initialState.portal = mockedPortal
}

export const createReduxStore = () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk, passcodeStore)),
  )
  return store
}

export const getStore = () => store



// WEBPACK FOOTER //
// ./src/store.js